// extracted by mini-css-extract-plugin
export default {"title":"CropImage_title__QhKzT","image":"CropImage_image__HDFK6","button":"CropImage_button__5Y98o","canvas":"CropImage_canvas__Pfoav"};